import { getFieldErrors } from '@/services/api';
import { Alert, LoadingSpinner } from '@/shared/components';
import type { TemplatePreview } from '../types/documentTemplates.types';

interface Props {
  isLoading: boolean;
  error: unknown;
  preview: TemplatePreview | null;
  className?: string;
}

function PreviewError({ error }: { error: unknown }) {
  const tokenErrors = getFieldErrors(error).body_html ?? [];
  return (
    <Alert variant="error" role="alert">
      <div>
        <span>
          {tokenErrors.length > 0
            ? 'The template contains placeholders that cannot be rendered:'
            : ((error as Error)?.message ?? 'The preview could not be generated.')}
        </span>
        {tokenErrors.length > 0 && (
          <ul className="mt-1 list-disc pl-5 font-mono text-xs">
            {tokenErrors.map((message) => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        )}
      </div>
    </Alert>
  );
}

export function PreviewFrame({ isLoading, error, preview, className = 'h-[60vh]' }: Props) {
  if (isLoading) return <LoadingSpinner size="lg" className="py-12" message="Rendering preview..." />;
  if (error != null) return <PreviewError error={error} />;
  if (!preview) return null;
  return (
    <iframe
      sandbox=""
      srcDoc={preview.html}
      title="Template preview"
      className={`w-full rounded-lg border border-mp-border bg-white ${className}`}
    />
  );
}
